import Messages from "./Messages";
import Input from "./Input";
import { Box } from "@mui/material";
import { Header } from "../widgets";
import { FormattedMessage } from "react-intl";

const ChatContainer = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden",
                position: "relative",
            }}
        >
            <Header>
                <FormattedMessage id="meetingPage.room.sidebar.chat.header" defaultMessage="Chat" />
            </Header>
            <Messages />
            <Input />
        </Box>
    );
};

export default ChatContainer;
